import React from 'react'
import ProjectDisplay from './ProjectDisplay'
import { PROJECTS } from '../common.js'
import { useScrollAnimation } from '../hooks/useScrollAnimation'
import { useTextScramble } from '../hooks/useTextScramble'

const ProjectsSection = () => {
	const [ref, isVisible] = useScrollAnimation(0.05)
	const scrambled = useTextScramble('WORK', isVisible, 900)

	return (
		<section id='projects' className='py-24 px-6 lg:px-12' ref={ref}>
			<div className='max-w-6xl mx-auto'>
				{/* Section header */}
				<div
					className='mb-16 transition-all duration-700'
					style={{
						opacity: isVisible ? 1 : 0,
						transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
					}}>
					<p className='text-blue-400 font-mono text-xs tracking-[0.25em] uppercase mb-3'>
						Portfolio
					</p>
					<h2 className='text-4xl lg:text-6xl font-bold text-white'>
						Selected{' '}
						<span className='bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent font-mono'>
							{scrambled}
						</span>
					</h2>
					<div className='mt-4 w-16 h-0.5 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full' />
				</div>

				{/* Projects grid */}
				<div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5'>
					{PROJECTS.map((project, i) => {
						const { title, desc, technologies, liveLink, githubLink, image } =
							project
						return (
							<div
								key={title}
								className='transition-all duration-700'
								style={{
									opacity: isVisible ? 1 : 0,
									transform: isVisible
										? 'translateY(0)'
										: 'translateY(40px)',
									transitionDelay: `${i * 80}ms`,
								}}>
								<ProjectDisplay
									title={title}
									desc={desc}
									technologies={technologies}
									liveLink={liveLink}
									githubLink={githubLink}
									image={image}
								/>
							</div>
						)
					})}
				</div>
			</div>
		</section>
	)
}

export default ProjectsSection
